<template>
  <v-card v-if="showDebug" class="debug-card" elevation="4">
    <v-card-title class="text-h6">
      🔍 Debug Info
      <v-spacer></v-spacer>
      <v-btn icon="mdi-close" @click="showDebug = false"></v-btn>
    </v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-title>Token</v-list-item-title>
          <v-list-item-subtitle>{{ token ? '✅ Presente' : '❌ Ausente' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Usuário</v-list-item-title>
          <v-list-item-subtitle>{{ user ? user.username : '❌ Não carregado' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Is Staff</v-list-item-title>
          <v-list-item-subtitle>{{ user?.is_staff ? '✅ Sim' : '❌ Não' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Is Superuser</v-list-item-title>
          <v-list-item-subtitle>{{ user?.is_superuser ? '✅ Sim' : '❌ Não' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Is Admin (Computed)</v-list-item-title>
          <v-list-item-subtitle>{{ isAdmin ? '✅ Sim' : '❌ Não' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Rota Atual</v-list-item-title>
          <v-list-item-subtitle>{{ $route.path }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Is Login Page</v-list-item-title>
          <v-list-item-subtitle>{{ isLoginPage ? '✅ Sim' : '❌ Não' }}</v-list-item-subtitle>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-title>Is Authenticated</v-list-item-title>
          <v-list-item-subtitle>{{ isAuthenticated ? '✅ Sim' : '❌ Não' }}</v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'DebugInfo',
  data() {
    return {
      showDebug: false
    }
  },
  computed: {
    ...mapState(['user', 'token']),
    ...mapGetters(['isAuthenticated', 'isAdmin']),
    isLoginPage() {
      return this.$route.path === '/login'
    }
  },
  mounted() {
    // Mostrar debug se pressionar Ctrl+Shift+D
    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        this.showDebug = !this.showDebug
      }
    })
  }
}
</script>

<style scoped>
.debug-card {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  background: #1e1e1e !important;
  color: white !important;
}
</style> 